export const getThingsBetweenTimestamps = (fromDate, toDate, activity) => {
  return `SELECT event_date FROM \`local-travel-guide.analytics_238617695.events_*\`,
    UNNEST (event_params) as params
    WHERE params.value.string_value = '${activity}'
    AND TIMESTAMP_MICROS(event_timestamp)
    BETWEEN CAST('${fromDate}' as TIMESTAMP) AND CAST('${toDate}' as TIMESTAMP)`;
};

export const getDestinationRequestBetweenTimestamps = (fromDate, toDate) => {
  return `SELECT event_date FROM \`local-travel-guide.analytics_238617695.events_*\`
    WHERE event_name = 'destination_request'
    AND TIMESTAMP_MICROS(event_timestamp)
    BETWEEN CAST('${fromDate}' as TIMESTAMP) AND CAST('${toDate}' as TIMESTAMP)`;
};

export const getCategoryClicksBetweenTimestamps = (fromDate, toDate) => {
  return `SELECT event_date, params FROM \`local-travel-guide.analytics_238617695.events_*\`,
    UNNEST(event_params) as params
    WHERE event_name = 'category_click' AND params.key = 'name'
    AND TIMESTAMP_MICROS(event_timestamp)
    BETWEEN CAST('${fromDate}' as TIMESTAMP) AND CAST('${toDate}' as TIMESTAMP)`;
};

export const getDestinationViewsByIdBetweenTimestamps = (id, fromDate, toDate) => {
  return `SELECT * FROM \`local-travel-guide.analytics_238617695.events_*\`,
    UNNEST (event_params) as params WHERE params.value.string_value = '${id}' AND
    event_name = 'destination_view' AND TIMESTAMP_MICROS(event_timestamp)
    BETWEEN CAST('${fromDate}' as TIMESTAMP) AND CAST('${toDate}' as TIMESTAMP)`;
};

export const getDestinationRequestsByIdBetweenTimestamps = (id, fromDate, toDate) => {
  return `SELECT * FROM \`local-travel-guide.analytics_238617695.events_*\`,
    UNNEST (event_params) as params WHERE params.value.string_value = '${id}' AND
    event_name = 'destination_request' AND TIMESTAMP_MICROS(event_timestamp)
    BETWEEN CAST('${fromDate}' as TIMESTAMP) AND CAST('${toDate}' as TIMESTAMP)`
};